import { arrayPush, autofill, formValues, arrayRemove } from 'redux-form';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { SnapcodesForm } from './SnapcodesForm';

const mapDispatchToProps = (dispatch: Dispatch, { form }: { form: string }) => ({
  addSnapcode: (value: { name: string; url: string; default?: boolean }) =>
    dispatch(arrayPush(form, 'snapcodes', value)),
  clear: () => dispatch(autofill(form, 'snapcodes', undefined)),
  removeSnapcode: (index: number) => dispatch(arrayRemove(form, 'snapcodes', index)),
});

export const SnapcodesFormContainer = formValues<any, any>({ snapcodes: 'snapcodes' })(
  connect(null, mapDispatchToProps)(SnapcodesForm),
);
